// extracted by mini-css-extract-plugin
var _1 = "tjs-colorscalerange-section__btn tjs-_buttons__btn tjs-_buttons__btn-primary";
var _2 = "tjs-colorscalerange-section__colorscalerange";
var _3 = "tjs-colorscalerange-section__field tjs-_form__field tjs-_form__input";
var _4 = "tjs-colorscalerange-section__title";
export { _1 as "btn", _2 as "colorscalerange", _3 as "field", _4 as "title" }
export default { "btn": _1, "colorscalerange": _2, "field": _3, "title": _4 }
